























































































































import { Component, Vue } from "vue-property-decorator";
import { listDevice, getEquipment, delDevice } from "@/api/equipment/device";
import AddOrEdit from "./addOrEdit.vue";
@Component({
  components: {
    AddOrEdit
  }
})
export default class Device extends Vue {
  public data = [];
  public defaultProps = {
    children: "children",
    label: "typeName"
  };
  activeAreaId = null;
  updateDisable = false;
  public queryParams = {
    cName: undefined,
    pageNum: 1,
    pageSize: 10,
    id: undefined
  };
  public expendKey = [];
  public addOrEditFlag = true;
  public addOrEditModal = false;
  public delDialogVisible = false;
  public list = [];
  public delList = [];
  public total = 0;
  public rowList = {};
  private loading = false;
  public created() {
    this.getTreeData();
  }
  public getList() {
    this.loading = true;
    listDevice(this.queryParams).then(res => {
      this.loading = false;
      if (res.code === 200) {
        this.list = res.rows;
        this.total = res.total;
      } else {
        this.$message.error(res.msg);
      }
    });
  }
  public getTreeData() {
    this.expendKey = [];
    getEquipment().then(res => {
      this.data = res.data;
      if(res.data && res.data.length > 0) {
        this.activeAreaId = res.data[0].id + "";
        this.queryParams.id = res.data[0].id;
        this.getList();
      }
      // res.data.some(item => {
      //   if (item.children && item.children.length) {
      //     item.children.some(device => {
      //       if (device.children && device.children.length) {
      //         this.expendKey.push(device.children[0].id);
      //         return true;
      //       }
      //     });
      //     return true;
      //   }
      // });
    });
  }
  public onSubmit() {
    this.queryParams.pageNum = 1;
    this.getList();
  }
  public showDialog(data) {
    this.addOrEditModal = typeof data === "boolean" ? data : false;
    if (typeof data === "boolean") {
      this.getList();
      // this.getTreeData();
    }
  }
  // 新增设备
  public addDevice() {
    this.addOrEditFlag = true;
    this.addOrEditModal = true;
  }
  // 删除设备
  public delDevice() {
    if (this.delList && this.delList.length === 0) {
      this.$message.error("请至少选择一个您要删除的项目");
    } else {
      this.delDialogVisible = true;
    }
  }
  // 编辑设备
  public updateDevice() {
    // this.rowList = editData;
    if (this.delList && this.delList.length === 0) {
      this.$message.error("请至少选择一个您要编辑的设备");
    } else {
      this.addOrEditModal = true;
      this.addOrEditFlag = false;
    }
  }
  public handleSelectionChange(val) {
    this.delList = val;
    if (val.length > 1) {
      this.updateDisable = true;
    } else {
      this.updateDisable = false;
      this.rowList = val[0];
    }
  }
  public deleteDeviceBtn() {
    const params = [];
    this.delList.map(item => {
      params.push(item.resourceBillId);
    });
    delDevice(params.join(",")).then(res => {
      this.delDialogVisible = false;
      if (res.code === 200) {
        this.$message.success("新增成功");
        this.getList();
      } else {
        this.$message.error(res.msg);
      }
    });
  }
  public handleClick(val) {
    this.queryParams.id = val.name;
    this.queryParams.pageNum = 1;
    this.getList(this.queryParams);
  }
}
